import { CrudMode } from '@ohpen/enso-ui';

export function getCrudMode(mode: CrudMode | null, isUsed: boolean | null): CrudMode {
  if (!mode || (mode === CrudMode.EDIT && isUsed)) {
    return CrudMode.VIEW;
  }

  return mode;
}
